export default {
  "name": "NCSelect",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCSelect",
  "label": "下拉",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "multiple": {
        "title": "多选",
        "description": "多选个",
        "type": "boolean"
      },
      "renderInTable": {
        "title": "renderInTable",
        "description": "renderInTable",
        "type": "boolean"
      },
      "supportSearch": {
        "title": "搜索",
        "description": "搜索",
        "type": "boolean"
      },
      "showStar": {
        "title": "必填标识",
        "description": "必填标识",
        "type": "boolean"
      },
      "disabled": {
        "title": "禁用",
        "description": "禁用",
        "type": "boolean",
        "default": false
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}